import EventSelectedInfo from '@/features/edit-event-strip';
import BookmarkButtonTypes from './bookmarkButtonTypes';
import StripBookmarks from './stripBookmarks';
import BookmarkEcgViewerWrapper from './bookmarkEcgViewerWrapper';
import BookmarkHrChart from './bookmarkHrChart';
import BookmarkHrChartOptions from './bookmarkHrChartOptions';
import useEcgBookmark from './useEcgBookmark';

type EcgBookmarkProps = {
  activeButton: any;
};

/**
 * Renders the ECG bookmark view of the ECG events tab, combining the toolbar, bookmark strips, selected-event info, ECG viewer and heart-rate chart. Replaces the viewer and chart with a no-data-recorded message when useEcgBookmark reports empty data, while the chart options row is always rendered below.
 *
 * @param props - Bookmark view inputs including the active event-type button passed down to the strip list.
 * @returns The bookmark view layout, with a no-data message in place of the viewer when nothing was recorded.
 */
const EcgBookmark = ({ activeButton }: EcgBookmarkProps) => {
  const {
    keyRecoil,
    isEmptyData,
    studyId,
    profileId,
    startReport,
    timezoneOffset,
    ecgDataMap,
    hrChartRef,
    handleClickArrowButton,
  } = useEcgBookmark();

  return (
    <>
      <BookmarkButtonTypes />
      <StripBookmarks
        activeButton={activeButton}
        ecgDataMap={ecgDataMap}
        studyId={studyId}
        profileId={profileId}
        timezoneOffset={timezoneOffset}
        startReport={startReport}
      />
      <div className="rhythm-events-content-container --min-width-strip-event">
        {isEmptyData ? (
          <div className="empty-data-container">
            <div className="empty-data-text">There is no data recorded</div>
          </div>
        ) : (
          <>
            <div className="event-select-ecg-viewer-wrapper">
              <EventSelectedInfo
                keyRecoil={keyRecoil}
                componentId="bookmark-selected-info"
                timezoneOffset={timezoneOffset}
                ecgDataMap={ecgDataMap}
              />
              <BookmarkEcgViewerWrapper
                ecgDataMap={ecgDataMap}
                timezoneOffset={timezoneOffset}
                profileId={profileId}
                studyId={studyId}
                handleClickArrowButton={handleClickArrowButton}
              />
            </div>
            <BookmarkHrChart
              ref={hrChartRef}
              ecgDataMap={ecgDataMap}
              timezoneOffset={timezoneOffset}
              studyId={studyId}
              profileId={profileId}
            />
          </>
        )}
        <BookmarkHrChartOptions timezoneOffset={timezoneOffset} />
      </div>
    </>
  );
};

export default EcgBookmark;
